package devxertech.com.pages.industries.healthCare.smartHealthCare

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.pages.commons.TeamService
import devxertech.com.theme.SitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.px

@Composable
fun SmartHealthCare (breakpoint: Breakpoint,
                       sitePalette: SitePalette){
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = if (breakpoint > Breakpoint.MD) 60.px else 60.px,
                bottom = if (breakpoint < Breakpoint.MD) 10.px else 50.px),
        contentAlignment = Alignment.Center
    ) {
        Column(
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            FieldTitleTextNormalSimple(
                "HEALTHCARE SOFTWARE DEVELOPMENT SERVICES",
                asH2 = true,
                color = sitePalette.commonSecondaryButtonColor.rgb,
                fontSize = if (breakpoint > Breakpoint.MD) 18.px else 15.px,
                textAlign = TextAlign.Center
            )
            Row(
                modifier = Modifier.flexWrap(FlexWrap.Wrap),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center
            ) {
                FieldTitleTextNormalSimple(
                    "MOVING TOWARD A",
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    fontSize = if (breakpoint > Breakpoint.MD) 35.px else 22.px,
                    fontWeight = 700
                )
                FieldTitleTextNormalSimple(
                    " SMART HEALTHCARE SYSTEM",
                    color = sitePalette.primary.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    fontSize = if (breakpoint > Breakpoint.MD) 35.px else 22.px,
                    fontWeight = 700
                )
            }
            Row(
                modifier = Modifier.fillMaxWidth()
                    .padding(bottom = if (breakpoint < Breakpoint.MD) 10.px else if (window.screen.width > 1600) 10.px else 0.px,
                        top = if (breakpoint < Breakpoint.MD) 10.px else 40.px)
                    .flexWrap(FlexWrap.Wrap),
                horizontalArrangement = Arrangement.Center
            ) {
                TeamService(
                    image = Res.Image.health_1,
                    title = "Patient Engagement \n" +
                            "Platforms",
                    description = " Our software solutions for patient engagement are modern, smart and user-centric so that the overall product fulfills the criteria of serving the user base in the best ways possible.",
                )
                TeamService(
                    image = Res.Image.health_2,
                    title = "EHR/EMR Software \n" +
                            "Development",
                    description = "EHR/EMR Software development solutions are expertly provided by devxer to ensure smooth workflow among hospitals, clinicians and patients along with building a synergized infrastructure for an easy access to records and data.",
                )
                TeamService(
                    image = Res.Image.health_3,
                    title = "Healthcare Data \n" +
                            "Analytics Solutions",
                    description = "Healthcare data has to be organized and arranged in a manner which yields important insights that lead to better work decisions in the future & Our team is adept at providing quality data analytics solutions to contribute towards better and enhanced product delivery.",
                )
                if (window.screen.width < 1600) {
                    TeamService(
                        image = Res.Image.health_4,
                        title = "Telehealth Software",
                        description = "Devxer provides high-end Telehealth Software Solutions to the Healthcare industry, enabling it to strengthen its digital footprint and enhancing its ability to serve the people in a smarter, innovative way.",
                    )


                    TeamService(
                        image = Res.Image.health_5,
                        title = "Health Tracking Apps",
                        description = "Health Tracking application software by devxer is intelligent, innovative and interactive to ensure better " +
                                "health outcomes of the patients and provides a structured, manageable platform for clinicians/doctors.",

                    )
                }
            }
            if (window.screen.width > 1600) {
                Row(modifier = Modifier.fillMaxWidth()
                    .padding(top = 0.px, bottom = if (window.screen.width > 1600) 0.px else 70.px).display(DisplayStyle.Flex)
                    .flexWrap(FlexWrap.Wrap),
                    horizontalArrangement = Arrangement.Center
                ) {
                    TeamService(
                        image = Res.Image.health_4,
                        title = "Telehealth Software",
                        description = "Devxer provides high-end Telehealth Software Solutions to the Healthcare industry, enabling it to strengthen its digital footprint and enhancing its ability to serve the people in a smarter, innovative way.",


                    )
                    TeamService(
                        image = Res.Image.health_5,
                        title = "Health Tracking Apps",
                        description = "Health Tracking application software by devxer is intelligent, innovative and interactive to ensure better " +
                                "health outcomes of the patients and provides a structured, manageable platform for clinicians/doctors.",


                    )
                }
            }
        }
    }
}
